var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass:
        "navbar navbar-expand-lg navbar-light bg-light shadow-sm bg-white",
      class: _vm.hidden
    },
    [
      _c("div", { staticClass: "container p-0" }, [
        _c(
          "div",
          { staticClass: "container-fluid p-0" },
          [
            _c(
              "router-link",
              {
                staticClass: "navbar-brand",
                attrs: { to: _vm.isLineLoggedIn ? "/line-liff" : "/", tag: "a" }
              },
              [
                _c("img", {
                  staticClass: "logo",
                  style: _vm.$mq.phone ? "padding: 0 1rem" : "",
                  attrs: {
                    src: "/static/img/main-logo.svg",
                    height: "38",
                    alt:
                      "BeNeat.co - ผู้ช่วยค้นหาแม่บ้านคุณภาพใกล้บ้านคุณ จองแม่บ้านออนไลน์ได้สะดวก รวดเร็ว พร้อมรับประกันคุณภาพ | Easy way to find your local cleaning expert"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex", attrs: { id: "mobile-display" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "navbar-toggler",
                    class: { open: _vm.isMenuOpen },
                    attrs: {
                      type: "button",
                      "aria-controls": "navbarSupportedContent-dev",
                      "aria-expanded": _vm.isMenuOpen ? "true" : "false",
                      "aria-label": "Toggle navigation"
                    },
                    on: { click: _vm.toggleMenu }
                  },
                  [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "p-0 collapse navbar-collapse mobile-menu-fullscreen",
            class: { show: _vm.isMenuOpen },
            attrs: { id: "navbarSupportedContent-dev" }
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-between align-items-center"
              },
              [
                _vm.user
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex gap-2 align-content-center pt-2 pb-4"
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: _vm.user.picture,
                              expression: "user.picture"
                            }
                          ],
                          staticClass: "rounded-circle",
                          attrs: {
                            height: "40",
                            width: "40",
                            alt: "User Picture"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column align-items-start gap-2"
                          },
                          [
                            _c("span", { staticClass: "text-capitalize" }, [
                              _vm._v(_vm._s(_vm.user.name))
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "navbar-nav ml-auto",
                class: _vm.hiddenWhenBooking
              },
              [
                _c(
                  "li",
                  { staticClass: "nav-item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link",
                        attrs: { to: "/promotions" },
                        on: { click: _vm.closeMenu }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.menu.promotions")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "nav-item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link",
                        attrs: { to: "/pricing" },
                        on: { click: _vm.closeMenu }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.menu.pricing")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "nav-item navbar-blog" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link link-icon",
                        attrs: { to: "/blog" }
                      },
                      [_vm._v("Blog")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        href: "https://line.me/R/ti/p/@BeNeat",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("message.menu.contact_customer_service")
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                !_vm.user
                  ? [
                      _c("li", { staticClass: "nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link",
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.$emit("openModal", "login")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.menu.login_signup")) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.user
              ? [
                  _c(
                    "label",
                    {
                      staticClass: "m-0 text-capitalize",
                      staticStyle: { padding: "5% 0" },
                      attrs: { for: "user-info" }
                    },
                    [_vm._v(_vm._s(_vm.$t("user_info.account")))]
                  ),
                  _vm._v(" "),
                  _c("ul", { staticClass: "navbar-nav ml-auto" }, [
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: { name: "Edit Profile" } },
                            on: { click: _vm.closeMenu }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "user-circle.svg",
                                folder: "icons",
                                alt: "user"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.$t("user_info.edit_profile")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/my-reservations" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "solar_calendar-outline.svg",
                                folder: "icons",
                                alt: "calendar"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("message.menu.my_reservations"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/inbox" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                folder: "icons",
                                icon: "solar_chat-round-line-outline.svg",
                                alt: "menu messages"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.$t("message.menu.messages")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/notifications" }
                          },
                          [
                            _c("i", {
                              staticClass: "fal fa-bell",
                              staticStyle: { "font-size": "24px" }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("message.menu.notifications"))
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/user/listings" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                folder: "icons",
                                icon: "hugeicons_home.svg",
                                alt: "menu address"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.$t("message.menu.my_listings")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/user/company-address" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "company-address.svg",
                                folder: "icons",
                                alt: "menu company address"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("message.menu.company_address"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/user/payment" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "payment-method.svg",
                                folder: "icons",
                                alt: "menu payment method"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("message.menu.payment_method"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/user/invite" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "gift.svg",
                                folder: "icons",
                                alt: "menu invite friends"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("message.menu.invite_friends"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/user/credits" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "coins.svg",
                                folder: "icons",
                                alt: "menu coins"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("message.menu.my_credits_number", {
                                      credits: _vm.user.totalCredits
                                    })
                                  ) +
                                  "\n              "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/user/my-vouchers" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "discount-tag.svg",
                                folder: "icons",
                                alt: "menu my vouchers"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("message.promo_code.my_vouchers"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link link-icon",
                            attrs: { to: "/user/personal-data-management" }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "shield-user.svg",
                                folder: "icons",
                                alt: "menu personal data management"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-wrap": "wrap",
                                  "line-height": "normal"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.menu.personal_data_management"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "m-0 text-capitalize",
                staticStyle: { padding: "5% 0" },
                attrs: { for: "myDropdown" }
              },
              [_vm._v(_vm._s(_vm.$t("select_language")))]
            ),
            _vm._v(" "),
            _c("ul", { staticClass: "navbar-nav ml-auto" }, [
              _c(
                "li",
                {
                  staticClass: "nav-item",
                  staticStyle: { position: "relative" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link dropdown-toggle",
                      attrs: {
                        href: "#",
                        id: "navbarLanguage",
                        role: "button",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "rounded-full",
                        attrs: { src: _vm.flagImage }
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$i18n.locale.toUpperCase()) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu dropdown-menu-v2",
                      attrs: { "aria-labelledby": "navbarLanguage" }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          staticStyle: { padding: "4% 10% !important" },
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setLanguage("en")
                            }
                          }
                        },
                        [_vm._v("\n              English\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          staticStyle: { padding: "4% 10% !important" },
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setLanguage("th")
                            }
                          }
                        },
                        [_vm._v("\n              ภาษาไทย\n            ")]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "m-0 text-capitalize",
                staticStyle: { padding: "5% 0" },
                attrs: { for: "myDropdown" }
              },
              [_vm._v(_vm._s(_vm.$t("message.menu.contact_with_line")))]
            ),
            _vm._v(" "),
            _c("ul", { staticClass: "navbar-nav ml-auto" }, [
              _c("li", { staticClass: "nav-item line-content" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "nav-link d-flex justify-content-center align-items-center text-capitalize",
                    staticStyle: { gap: "4px" },
                    attrs: {
                      href: "https://line.me/R/ti/p/@BeNeat",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    },
                    on: { click: _vm.closeMenu }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "24px", height: "24px" },
                      attrs: {
                        src: "/static/img/icons/line-icon.svg",
                        alt: "Line Icon"
                      }
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("line_consult")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.user
                ? _c(
                    "li",
                    { staticClass: "nav-item mt-5", attrs: { id: "sign-out" } },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link d-flex gap-2 align-items-center justify-content-center text-capitalize",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit("openLogoutDialog")
                            }
                          }
                        },
                        [
                          _c("SVGIcon", {
                            staticClass: "text-main-red",
                            attrs: {
                              icon: "logout-square.svg",
                              folder: "icons",
                              alt: "logout icon"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-main-red" }, [
                            _vm._v(_vm._s(_vm.$t("message.menu.logout")))
                          ])
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse navbar-collapse",
            attrs: { id: "navbarSupportedContent-dev" }
          },
          [
            _c(
              "ul",
              {
                staticClass: "navbar-nav ml-auto",
                class: _vm.hiddenWhenBooking
              },
              [
                _c(
                  "li",
                  { staticClass: "nav-item" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "nav-link", attrs: { to: "/promotions" } },
                      [_vm._v(_vm._s(_vm.$t("message.menu.promotions")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "nav-item" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "nav-link", attrs: { to: "/pricing" } },
                      [_vm._v(_vm._s(_vm.$t("message.menu.pricing")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.user
                  ? _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: { to: "/my-reservations" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("message.menu.my_reservations"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.user
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "nav-item dropdown dropdown-md dropdown-box"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-toggle nav-link",
                            attrs: { href: "#", "data-toggle": "dropdown" }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("message.menu.messages")) +
                                "\n            "
                            ),
                            _vm.newInbox
                              ? [
                                  _c(
                                    "svg",
                                    { staticClass: "notification-alert" },
                                    [
                                      _c("circle", {
                                        attrs: { cx: "3", cy: "3", r: "3" }
                                      })
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu row custom-dropdown",
                            class: [
                              !_vm.$mq.desktop ? "user-menu-md" : "user-menu-lg"
                            ]
                          },
                          [
                            _c("div", { staticClass: "inbox-group" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "row text-order-title my-3" },
                                  [
                                    _c("div", { staticClass: "col-6 p-0" }, [
                                      _c("strong", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t("message.menu.messages")
                                            ) +
                                            " "
                                        ),
                                        _vm.inboxMessages.length > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.inboxMessages.length
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-6 p-0 text-right" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "text-primary-link",
                                            attrs: { to: "/inbox" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.see_all")
                                              ) + " "
                                            ),
                                            _c("i", {
                                              staticClass: "fal fa-angle-right"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _vm.isFetchingMessage
                                    ? [_vm._m(0)]
                                    : _vm._l(_vm.inboxMessages, function(
                                        chat,
                                        index
                                      ) {
                                        return _c(
                                          "router-link",
                                          {
                                            key: index,
                                            staticClass: "no-style",
                                            attrs: { to: _vm.convertUrl(chat) },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.$emit(
                                                  "hasReadMessage",
                                                  chat.last_message
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-start align-items-center"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "mr-3" },
                                                  [
                                                    chat.professional
                                                      ? _c("img", {
                                                          staticClass:
                                                            "rounded-circle img-fluid",
                                                          attrs: {
                                                            src: _vm.$emit(
                                                              "showPicture",
                                                              chat.professional
                                                            ),
                                                            width: "50"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "text-small" },
                                                  [
                                                    _c(
                                                      "label",
                                                      { staticClass: "mb-0" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("firstName")(
                                                              chat.professional
                                                                .full_name
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "m-0" },
                                                      [
                                                        chat.last_message
                                                          .message_type_id !== 1
                                                          ? [
                                                              chat.last_message
                                                                .sender_type ===
                                                              "user"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          chat
                                                                            .last_message
                                                                            .message_type_id ===
                                                                            2
                                                                            ? _vm.$t(
                                                                                "message.inbox.you_sent_photo"
                                                                              )
                                                                            : _vm.$t(
                                                                                "message.inbox.you_sent_location"
                                                                              )
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          chat
                                                                            .last_message
                                                                            .message_type_id ===
                                                                            2
                                                                            ? _vm.$t(
                                                                                "message.inbox.sent_photo"
                                                                              )
                                                                            : _vm.$t(
                                                                                "message.inbox.sent_location"
                                                                              )
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ])
                                                            ]
                                                          : [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    chat
                                                                      .last_message
                                                                      .message
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "m-0 text-secondary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.convertTimespan(
                                                                chat
                                                                  .last_message
                                                                  .create_date
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._.last(_vm.inboxMessages).id !==
                                            chat.id
                                              ? _c("hr")
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                  _vm._v(" "),
                                  !_vm.isFetchingMessage &&
                                  _vm.inboxMessages.length <= 0
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "text-muted text-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.menu.dropdown_message.empty_message"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "notification-group" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "row text-order-title my-3" },
                                  [
                                    _c("div", { staticClass: "col-6 p-0" }, [
                                      _c("strong", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.menu.notifications"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _vm.notifications.length > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.notifications.length
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-6 p-0 text-right" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "text-primary-link",
                                            attrs: { to: "/notifications" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.see_all")
                                              ) + " "
                                            ),
                                            _c("i", {
                                              staticClass: "fal fa-angle-right"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _vm.isFetchingNoti
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "text-center w-100 mb-4"
                                        },
                                        [_vm._m(2)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.notifications, function(
                                    notification,
                                    index
                                  ) {
                                    return _c(
                                      "router-link",
                                      {
                                        key: index,
                                        staticClass: "no-style",
                                        attrs: {
                                          to: {
                                            name: "My Reservation",
                                            params: {
                                              id:
                                                notification.notification_data
                                                  .order_id
                                            }
                                          }
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.$emit(
                                              "hasReadActivity",
                                              notification.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-start align-items-center"
                                          },
                                          [
                                            _c("div", { staticClass: "mr-3" }, [
                                              _c("img", {
                                                staticClass:
                                                  "rounded-circle img-fluid",
                                                attrs: {
                                                  src:
                                                    notification
                                                      .notification_data
                                                      .professional_picture,
                                                  width: "50"
                                                }
                                              })
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "text-small" },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "label",
                                                    { staticClass: "mb-0" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("firstName")(
                                                            notification
                                                              .notification_data
                                                              .professional_name
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        notification.activity_type_name
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                  notification.notification_data
                                                    .order_code
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          #" +
                                                            _vm._s(
                                                              notification
                                                                .notification_data
                                                                .order_code
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : notification
                                                        .notification_data
                                                        .order_id
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          #" +
                                                            _vm._s(
                                                              notification
                                                                .notification_data
                                                                .order_id
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-secondary"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.convertTimespan(
                                                            notification.time
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._.last(_vm.notifications).id !==
                                        notification.id
                                          ? _c("hr")
                                          : _vm._e()
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  !_vm.isFetchingNoti &&
                                  _vm.notifications.length <= 0
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "text-muted text-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.menu.dropdown_message.empty_notification"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "nav-item navbar-blog" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link link-icon",
                        attrs: { to: "/blog" }
                      },
                      [_vm._v("Blog")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.user
                  ? _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link",
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit("openModal", "login")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("message.menu.login_signup")) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.user
                  ? _c("li", { staticClass: "nav-item dropdown" }, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-toggle nav-link",
                          attrs: {
                            href: "#",
                            id: "navbarUser",
                            "data-toggle": "dropdown",
                            "aria-expanded": "false"
                          }
                        },
                        [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: _vm.user.picture,
                                expression: "user.picture"
                              }
                            ],
                            staticClass: "rounded-circle",
                            attrs: { width: "30" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          attrs: { "aria-labelledby": "navbarUser" }
                        },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                !_vm.$mq.desktop
                                  ? "text-small user-menu-md overflow-auto"
                                  : "user-menu-lg"
                              ]
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/user/edit" }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-user" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.menu.edit_profile")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/user/listings" }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-home" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.menu.my_listings")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/user/company-address" }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-building" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.menu.company_address")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/user/payment" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fal fa-credit-card"
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.menu.payment_method")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/user/notifications" }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-bell" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.menu.notification_settings"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/rewards" }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-trophy-alt" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.menu.beneat_rewards")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/user/invite" }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-gift" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.menu.invite_friends")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/user/credits" }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-wallet" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.menu.my_credits_number",
                                          {
                                            credits: _vm.user.totalCredits
                                          }
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/user/my-vouchers" }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-ticket" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.promo_code.my_vouchers")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: {
                                    to: "/user/personal-data-management"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fal fa-user-shield"
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.menu.personal_data_management"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: {
                                    href: "https://line.me/R/ti/p/@BeNeat",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-comments" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.menu.contact_customer_service"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.$emit("openLogoutDialog")
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-sign-out" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("message.menu.logout")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$mq.desktop
                  ? _c("li", { staticClass: "nav-item dropdown" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link dropdown-toggle",
                          attrs: {
                            href: "#",
                            id: "navbarLanguage",
                            role: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          }
                        },
                        [_c("img", { attrs: { src: _vm.flagImage } })]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          attrs: { "aria-labelledby": "navbarLanguage" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.$emit("setLocaleLanguage", "en")
                                }
                              }
                            },
                            [_vm._v("\n              English\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.$emit("setLocaleLanguage", "th")
                                }
                              }
                            },
                            [_vm._v("\n              ภาษาไทย\n            ")]
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center w-100 mb-4" }, [
      _c("div", { staticClass: "lds-ellipsis" }, [
        _c("div"),
        _vm._v(" "),
        _c("div"),
        _vm._v(" "),
        _c("div"),
        _vm._v(" "),
        _c("div")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-335c325e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335c325e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/materials/MenuBar.vue
// module id = 1439
// module chunks = 0